module.exports = __webpack_public_path__ + "img/login-ilu-x2.c4b7137a.png";